import { render, staticRenderFns } from "./helsana.vue?vue&type=template&id=6345243c&scoped=true"
import script from "./helsana.vue?vue&type=script&lang=js"
export * from "./helsana.vue?vue&type=script&lang=js"
import style0 from "./helsana.vue?vue&type=style&index=0&id=6345243c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345243c",
  null
  
)

export default component.exports